// ** Icon Types & Constants
// Definicje typów i stałych dla systemu ikon

// Dostępne rozmiary ikon
export const IconSizes = {
	XS: "xs", // 10px
	SM: "sm", // 12px
	MD: "md", // 14px
	LG: "lg", // 16px
	XL: "xl", // 18px
	XXL: "xxl", // 20px
	EM1: "1em", // 1em
};

// Mapowanie rozmiarów na piksele
export const sizeMap = {
	[IconSizes.XS]: "10px",
	[IconSizes.SM]: "12px",
	[IconSizes.MD]: "14px",
	[IconSizes.LG]: "16px",
	[IconSizes.XL]: "18px",
	[IconSizes.XXL]: "20px",
	[IconSizes.EM1]: "1em",
};

// Dostępne warianty ikon
export const IconVariants = {
	SOLID: "solid",
	REGULAR: "regular",
	LIGHT: "light",
};

// Default props dla komponentu Icon
export const defaultIconProps = {
	size: IconSizes.EM1,
	variant: IconVariants.SOLID,
	color: "currentColor",
	"aria-hidden": true,
	focusable: false,
};

// PropTypes schema (dla dokumentacji i validation)
export const iconPropTypes = {
	name: "string.isRequired",
	size: `oneOf([${Object.values(IconSizes)
		.map((s) => `'${s}'`)
		.join(", ")}])`,
	variant: `oneOf([${Object.values(IconVariants)
		.map((v) => `'${v}'`)
		.join(", ")}])`,
	color: "string",
	className: "string",
	style: "object",
	onClick: "func",
	customMargin: "string",
	height: "string",
	width: "string",
	verticalAlign: "string", // 'baseline' | 'middle' | 'top' | 'bottom' | 'text-top' | 'text-bottom'
};
